import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Rupies from "../../Assets/Images/OMS/Rupies.svg";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  //   pt: 2,
  //   px: 4,
  //   pb: 3,
  p: 2,
};

function AddLoadingDetails({ open, handleClose }) {
  const formik = useFormik({
    initialValues: { supplier_Name: "", billed_to: "" },
    // validate,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  return (
    <div>
      <Modal
        className="p-0"
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Add new loading details</h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="row mt-3">
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="crop_Weight_Gross(MT)"
                    // onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                    // value={formik.values.supplier_Name}
                    label="Crop Weight Gross (MT)"
                  />
                  {formik.errors.supplier_Name ? (
                    <div className="text-red-600 text-sm">
                      {formik.errors.supplier_Name}
                    </div>
                  ) : null}
                </div>
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="unloading_weight/bag"
                    label="Unloading weight/bag"
                    // onBlur={formik.handleBlur}
                    // onChange={formik.handleChange}
                    // value={formik.values.billed_to}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="Purchase price from retailer"
                    // onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                    // value={formik.values.supplier_Name}
                    label="Purchase price from retailer"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img src={Rupies} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {formik.errors.supplier_Name ? (
                    <div className="text-red-600 text-sm">
                      {formik.errors.supplier_Name}
                    </div>
                  ) : null}
                </div>
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="total_price_for_commodity"
                    label="Total price for commodity"
                    // onBlur={formik.handleBlur}
                    // onChange={formik.handleChange}
                    // value={formik.values.billed_to}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img src={Rupies} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Bag type
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={age}
                      label="Field Executive"
                      // onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  {formik.errors.supplier_Name ? (
                    <div className="text-red-600 text-sm">
                      {formik.errors.supplier_Name}
                    </div>
                  ) : null}
                </div>
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="no_of_gunny_bags(MT)"
                    label="No of gunny bags(MT)"
                    // onBlur={formik.handleBlur}
                    // onChange={formik.handleChange}
                    // value={formik.values.billed_to}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col col-md-6 col-lg-6 col-sm-6">
                  <TextField
                    size="small"
                    fullWidth
                    name="bag_cost"
                    label="Bag cost"
                    // onBlur={formik.handleBlur}
                    // onChange={formik.handleChange}
                    // value={formik.values.billed_to}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img src={Rupies} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="mt-3 flex">
            <Button
              fullWidth
              variant="contained"
              className="me-3"
              style={{ backgroundColor: "#131542" }}
            >
              Add
            </Button>
            <Button
              variant="contained"
              fullWidth
              style={{ backgroundColor: "#C7081E" }}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default AddLoadingDetails;
